import Vue from "vue";
import VueRouter from "vue-router";
import pay from "../views/payment/pay.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "支付",
    component: pay,
  },
  {
    path: "/pay",
    name: "支付",
    component: pay,
  },
  {
    path: "/cashier",
    name: "收银台",
    component: () => import("../views/payment/cashier.vue"),
  },
  {
    path: "/commentCashier",
    name: "收银台",
    component: () => import("../views/payment/commentCashier.vue"),
  },
  {
    path: "/paySuccess",
    name: "支付成功",
    component: () => import("../views/payment/paySuccess.vue"),
  },
  {
    path: "/comment",
    name: "评论页",
    component: () => import("../views/payment/comment.vue"),
  },
  {
    path: "/commentSuccess",
    name: "评论成功",
    component: () => import("../views/payment/commentSuccess.vue"),
  },
  {
    path: "/openCard",
    name: "会员新开卡",
    component: () => import("../views/membershipCard/openCard.vue"),
  },
  {
    path: "/rechargeCard",
    name: "会员卡充值",
    component: () => import("../views/membershipCard/rechargeCard.vue"),
  },
  {
    path: "/cardDetail",
    name: "套餐详情",
    component: () => import("../views/membershipCard/cardDetail.vue"),
  },
  {
    path: "/memberInfo",
    name: "会员信息",
    component: () => import("../views/membershipCard/memberInfo.vue"),
  },
  {
    path: "/openCardSuccess",
    name: "办卡成功页",
    component: () => import("../views/membershipCard/openCardSuccess.vue"),
  },
  {
    path: "/admin",
    name: "宝虎科技开通支付",
    component: () => import("../views/admin")
  },
  {
    path: "/subject",
    name: "宝虎科技开通支付",
    component: () => import("../views/admin/subject.vue")
  },
  {
    path: "/operate",
    name: "宝虎科技开通支付",
    component: () => import("../views/admin/operate.vue")
  },
  {
    path: "/weapp",
    name: "宝虎科技开通支付",
    component: () => import("../views/admin/weapp.vue")
  },
  {
    path: "/balance",
    name: "宝虎科技开通支付",
    component: () => import("../views/admin/balance.vue")
  }
];

let router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  document.title = to.name || "宝虎";
  next();
});

export default router;
